export default "__VITE_ASSET__44265a97__"